import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import JoinWaitlist from './JoinWaitlist/JoinWaitlist';
import LandingPage from './LandingPage/LandingPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/waitlist" element={<JoinWaitlist />} />
      </Routes>
    </Router>
  );
}

export default App;
